import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import type { ConditionPanelHost } from '@/types/advanceFilter';

/**
 * Open/anchor/close plumbing shared by every condition popover. A condition is
 * either hosted — the filter strip owns the popover and anchors it to a chip,
 * so there is no trigger button and the popover is open from mount — or
 * self-managed, where it renders its own trigger and opens on click.
 *
 * `triggerRef` is a callback ref on purpose: storing the element in state is
 * what re-renders the popover once its anchor exists.
 */
export const useConditionPanel = (host, onPanelClose) => {
  const $ = _c(12);
  const [triggerEl, setTriggerEl] = useState(null);
  const [isOpen, setIsOpen] = useState(!!host);
  let t0;
  if ($[0] !== host || $[1] !== onPanelClose) {
    t0 = () => {
      setIsOpen(false);
      onPanelClose?.();
      host?.onClose();
    };
    $[0] = host;
    $[1] = onPanelClose;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const close = t0;
  const t1 = !!host;
  const t2 = host?.anchorEl ?? triggerEl;
  let t3;
  if ($[3] !== close || $[4] !== isOpen) {
    t3 = () => isOpen ? close() : setIsOpen(true);
    $[3] = close;
    $[4] = isOpen;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== close || $[7] !== isOpen || $[8] !== t1 || $[9] !== t2 || $[10] !== t3) {
    t4 = {
      isHosted: t1,
      isOpen,
      triggerRef: setTriggerEl,
      anchorEl: t2,
      close,
      toggle: t3
    };
    $[6] = close;
    $[7] = isOpen;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
};